<template>
  <layout-pondlogs
    containerType="card-footer"
    v-loading="loading"
    class="stock-medicine-view"
  >
    <template slot="title">{{ "Lab Tests" }}</template>

    <template slot="header"
      ><lab-test-action-bar></lab-test-action-bar
    ></template>

    <div slot="pondlogs-default-layout-main" :key="location._id">
      <lab-test-table />
    </div>
  </layout-pondlogs>
</template>

<script>
import labTestActionBar from "@/components/culture/labTestActionBar";
import labTestTable from "@/components/culture/labTestTable";

import labTestsMod from "@/store/components/labTests";
import resource from "@/store/components/resource";

import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { labTestActionBar, labTestTable },
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      loading: false
    };
  },
  created() {
    const storeModules = {
      resource,
      labTests: labTestsMod
    };
    for (const moduleName in storeModules) {
      if (!this.$store.hasModule(moduleName)) {
        this.$store.registerModule(moduleName, storeModules[moduleName]);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    const storeModules = {
      resource,
      labTests: labTestsMod
    };
    for (const moduleName in storeModules) {
      if (this.$store.hasModule(moduleName)) {
        this.$store.unregisterModule(moduleName, storeModules[moduleName]);
      }
    }
    next();
  },
  computed: {
    ...mapGetters("user", {
      getCurrUserLocation: "getCurrUserLocation"
    }),
    ...mapGetters("pond", {
      getPonds: "getPonds"
    }),
    location: function() {
      return this.getCurrUserLocation;
    }
  },
  async mounted() {
    await this.initComponent();
  },
  methods: {
    ...mapActions("pond", {
      fetchAllPonds: "fetchAllPonds"
    }),
    ...mapActions("resource", {
      fetchAllLabs: "fetchAllLabs"
    }),
    async initComponent() {
      try {
        this.loading = true;
        const payload = {
          location_id: "",
          get_all: true
        };
        await this.fetchAllLabs(payload);
        await this.fetchAllPonds({ location_id: this.location._id });
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.stock-medicine-view {
}
</style>
